<template>
  <div class="live_box">
    <div class="live_head">
      <div class="live_head_conter">
        <div class="live_title">
          <span class="live_title_back" @click="back"><i></i>返回</span>
          <span>{{ course.course_name }}</span>
        </div>
        <div class="live_user_name">
          <span v-if="userInfo"
            >{{ user_nickname }}丨<span @click="outLogin">退出登录</span></span
          >
          <span v-else
            ><span @click="showDialogLogin(true)">登录</span>丨<span
              @click="showDialogSignIn(true)"
              >注册</span
            ></span
          >
        </div>
      </div>
    </div>
    <div class="live_main">
      <div class="live_main_left">
        <div id="id_video_container" style="width:100%;"></div>
      </div>
      <div class="live_main_right">
        <div class="chat_wrap_title " v-if="user_func == 0">
          <span class="chat_wrap_title_student">问答专区</span>
        </div>
        <div v-if="user_func != 0" class="chat_wrap_title">
          <div :class="{chat_tab_active:tab_mark === 0}" class="chat_tab" @click="tab_mark = 0">
            <span>问答专区</span>
          </div>
          <div :class="{chat_tab_active:tab_mark === 1}" class="chat_tab" @click="tab_mark = 1">
            <span>用户列表</span>
            <span class="chat_tab_online">（在线{{ client_count }}人）</span>
          </div>
        </div>
        <div class="chat_wrap" v-if="tab_mark === 0">
          <div
            class="chat-con clearfix"
            id="chat_con"
            v-for="(val, key) in chatLog"
            :key="key" @click="recall(val)"
          >
            <!-- <p >{{item.message}}</p><br/> -->
            <!-- <div class="chat-item item-right clearfix"><span class="img fr"></span><span class="message fr">你是傻叉吗</span></div> -->
            <div class="chat-item item-left clearfix rela">
              <span class="uname"
                >{{ user_func === 0 ? val.name : val.phone+'('+val.name+')' }}:</span
              ><span class="ucontent">{{ val.content }}</span>
            </div>
          </div>
          <div class="tooltip" v-if="show_tooltip">
            <div class="tooltip_title">是否撤回消息</div>
            <div class="tooltip_btn_box">
              <div class="tooltip_btn" @click="isRecall(1)">是</div>
              <div class="tooltip_btn" style="margin-left: 14px;" @click="isRecall(2)">否</div>
            </div>
          </div>
        </div>
        <div class="edit-text_box">
          <textarea
            class="edit-text"
            placeholder="在这里跟老师提问互动"
            ref="r_editText"
            v-model="editText"
          ></textarea
          ><a href="javascript:;" class="btn-a" @click="sendEnTer">发送</a>
        </div>
        <div class="user_wrap" v-if="tab_mark === 1">
          <div
            class="user-con clearfix"
            id="chat_con"
            v-for="(val, key, idx) in client_list"
            :key="idx"
          >
            <div class="user-item item-left clearfix rela">
              <img src="../assets/page_icon/login.png" alt="">
              <span v-if="val.client_info.realname!=''">{{val.client_info.phone+'('+val.client_info.realname+')'}}</span>
              <span v-else>{{val.client_info.phone}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 在线用户列表 -->
    <!-- <div class="online_uer_list"> -->
    <!-- <div class="online_list_warp">
      <div
        v-show="isActive"
        class="online_uer_list"
        :class="isActive ? 'online_active' : 'close'"
      >
        <el-scrollbar style="height:100%;">
          <ul v-if="list_flag">
            <li class="online_num">在线人数 {{ len }}</li>
            <li
              v-for="(val, key) in client_list"
              :key="key"
              class="online_user_item"
            >
              <div class="wrap_dot"><i class="online_list_dot"></i></div>
              {{ val }}
            </li>
          </ul>
        </el-scrollbar>
      </div>
    </div> -->

    <!-- 提示框 -->
    <el-dialog
      title="提示"
      class="live_tit_box"
      :visible.sync="centerDialogVisible"
      width="20%"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <span>{{ msg }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="toOrder">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
var ws;
// import VueSocketIO from "vue-socket.io";
import { TcPlayer } from '@/js/TcPlayer-2.4.1'
import { mapState, mapGetters } from "vuex";
import store from "../store";
export default {
  computed: {
    ...mapState(["dialogSignIn", "dialogLogin", "userInfo"])
  },
  data() {
    return {
      tab_mark:0,
      centerDialogVisible: false,
      msg: "",
      editText: "",
      room_id: null,
      chatLog: [],
      client_list: {},
      now_client_list: {},
      course: "",
      list_flag: true,
      isActive: false,
      len: null,
      user_id: "",
      user_func: 0,
      user_nickname:"",
      user_realname: "",
      phone: "",
      livePlayer: null,
      client_count:0,
      current_time:0,
      recall_msg: null,
      show_tooltip: false,
      startTime: '',
      endTime: '',
      course_id: '',
      lesson_id: '',
      keepIncr: null,
      timer: null,
      isLeave: true,
      hasPause: true
    };
  },
  created() {
    this.getLiveID();
    this.getData();

    // 键盘事件
    let that = this;
    document.onkeydown = function(e) {
      if(that.$route.path === '/live'){
        let key = e.keyCode;
        if (key === 13 && !window.event.ctrlKey) {
          // 按enter键发送信息
          that.sendEnTer(); //方法
          return false;
        }
      }
    };
  },
  mounted() {
    // var fls = this.flashChecker();
    // if (!fls.f) {
    //   if (
    //     confirm(
    //       "您的浏览器未安装Flash插件导致无法播放，建议使用QQ浏览器和360浏览器等，或者现在安装Flash插件？"
    //     )
    //   ) {
    //     window.location.href = "http://www.flash.cn";
    //   }else{
    //     this.$router.go(-1)
    //   }
    // }else{

    // }
    // window.addEventListener('beforeunload',e => {
    //   console.log("我执行beforeunload了")
    //   this.over && this.over();
    //   this.sumbitHistory();
    // })

    window.onbeforeunload = (e) =>{
      e.returnValue = '关闭提示'
      // this.over && this.over();
      if(this.hasPause){
        if(this.keepIncr){
          this.sumbitHistory(()=>{
            this.startTime=Date.parse(new Date())
            clearInterval(this.timer)
            this.timer=null
            this.current_time=0
            this.timer = setInterval(() => {
              let num = this.current_time;
              this.current_time = ++num;
            },1000)
          })
        }
      }
    }
    this.course_id=this.$route.query.course_id
    this.lesson_id=this.$route.query.lesson_id
  },
  updated() {
    if(this.tab_mark === 0){
      document.querySelector(".chat_wrap").scrollTo(0, 99999999999);
    }
  },
  beforeDestroy() {
    this.over && this.over();
    if(this.hasPause){
      if(this.keepIncr){
        clearInterval(this.keepIncr)
        clearInterval(this.timer)
        this.keepIncr=null
        this.timer=null
        this.sumbitHistory();
      }
    }
    this.isLeave=false
  },
  methods: {
    getLiveID() {
      this.$http
        .get("/api/v2/Live/getLive", {
          headers: {
            token:
              localStorage.getItem("token") !== null
                ? localStorage.getItem("token")
                : ""
          },
          params: {
            lesson_id: this.$route.query.lesson_id
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            // ws = new WebSocket("ws://cssapptk.hanmojy.com:7272");
            // ws = new WebSocket("wss://apis.hanmoedu.com/wss/");
            this.room_id = res.data.data.live_id;
            this.startTime=Date.parse(new Date())
            this.timer = setInterval(() => {
              let num = this.current_time;
              this.current_time = ++num;
            },1000)
            this.sumbitPlayTime();
            if (localStorage.getItem("token")) {
              this.getUserInfo();
            }
            // var that=this;
            // var name = this.$store.state.userInfo,user_id=localStorage.getItem("token"),room_id=this.room_id;
            // ws.onopen=function(){
            //     console.log("已连接");

            //     var login_data = '{"type":"login","client_name":"'+name+'","room_id":"'+room_id+'","user_id":"'+user_id+'"}';
            //     ws.send(login_data);

            // }

            // // 服务端发来消息时
            // ws.onmessage=function(e) {

            //     var data = JSON.parse(e.data);

            //     switch(data.type){
            //         // 服务端ping客户端
            //         case 'ping':

            //             ws.send('{"type":"pong"}');
            //             break;
            //         // 登录 更新用户列表
            //         case 'login':

            //             if(data['client_list']){
            //                 that.client_list = data.client_list;
            //             }else{
            //                 that.client_list[data.client_id] = data.client_name;
            //             }

            //             break;
            //         // 发言
            //         case 'say':
            //             // say(data.from_client_id, data.from_client_name, data.content, data.time);
            //             var chat={
            //                 content: data.content,
            //                 name: data.from_client_name,
            //                 time: data.time,
            //                 id: data.from_client_id
            //             };

            //             that.chatLog.push(chat)

            //             break;
            //         // 用户退出 更新用户列表
            //         case 'logout':
            //             delete that.client_list[data.from_client_id];
            //     }
            // }

            // ws.onerror = function() {
            //     console.log("出现错误");
            // };

            // this.fileID=res.data.data.lesson_media_uri;
            document.querySelector("#id_video_container").style.height= " 100%";
            document.getElementById('id_video_container').innerHTML = ""
            var option = {
              // live_url: res.data.data.live_pay_flv_url,
              // live_url2: res.data.data.live_pay_rtmp_url,
              // width: 480,
              // height: 320
              "flv": res.data.data.live_pay_flv_url+"?"+new Date().getTime(),
              "m3u8": res.data.data.live_pay_mu_url+"?"+new Date().getTime(),
              live: true,
              autoplay: true,
              flash: false,
              h5_flv: true,
              width: "100%",
              height: "100%",
              remember: 1,
              firstPlay: true,
              wording: {
                5: '当前环境不支持播放该视频格式,请检查Flash 插件是否开启或者使用谷歌、火狐、qq等浏览器！！'
              },
              listener: (d) =>{
                if(this.isLeave){
                  if(d.type=="play"){
                    this.hasPause=true
                    if(!this.keepIncr){
                      this.startTime=Date.parse(new Date())
                      clearInterval(this.timer)
                      this.timer=null
                      this.current_time=0
                      this.timer = setInterval(() => {
                        let num = this.current_time;
                        this.current_time = ++num;
                      },1000)
                      this.reportedStudy()
                    }
                  }else if(d.type=="pause"){
                    this.hasPause=false
                    clearInterval(this.keepIncr)
                    this.keepIncr=null
                    this.sumbitHistory(()=>{
                      clearInterval(this.timer)
                      this.timer=null
                    })
                  }
                }
              }
            };
            this.livePlayer = new TcPlayer("id_video_container", option)


            // livePlayer = new TcPlayer("id_video_container", option);
            // const playerbox = document.querySelector("#video_10000000_embed");
            // const playerbox = document.querySelector(
            //   "#id_video_container embed"
            // );
            // console.log(livePlayer);
            // if (playerbox) {
            //   playerbox.style.width = "100%";
            //   playerbox.style.height = "100%";
            //   playerbox.style.boxSizing = "border-box";
            // }

            // document.querySelector("#id_video_container").style.height = "100%";
          } else if (res.data.code === 0) {
            this.$message.error(res.data.msg);
          } else if (res.data.code === 10001) {
            //未登录检测
            store.commit("setDialogLogin", true);
          } else if (res.data.code === 10002) {
            //未购买检测
            this.msg = res.data.msg;
            this.centerDialogVisible = true;
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    getUserInfo() {
      //请求用户信息
      this.$http
        .get("/api/v2/User/getUserInfo", {
          headers: {
            token: localStorage.getItem("token")
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            store.commit("setUserInfo", res.data.data.mobile);
            this.user_id = res.data.data.id;
            this.user_func = res.data.data.user_func;
            this.user_nickname = res.data.data.user_nickname;
            this.user_realname = res.data.data.user_realname;
            this.phone = res.data.data.mobile;
            this.connect();
          } else if (res.data.code === 0) {
            this.$message(res.data.msg);
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    getData() {
      this.$http
        .get("/api/v2/course/getCourseLesson", {
          params: {
            course_id: this.$route.query.course_id
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            this.course = res.data.data.course;
            // this.lesson=res.data.data.lesson;
            this.$changeTitle(res.data.data.course.course_name + "--");
          } else if (res.data.code === 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    //定时上报学习时长
    reportedStudy() {
      this.keepIncr= setInterval(() => {
        this.sumbitHistory(()=>{
          this.startTime=Date.parse(new Date())
          clearInterval(this.timer)
          this.timer=null
          this.current_time=0
          this.timer = setInterval(() => {
            let num = this.current_time;
            this.current_time = ++num;
          },1000)
        })
      },50000)
    },
    // 提交用户播放次数
    sumbitPlayTime(course_id, lesson_id, lesson_type) {
      this.$http.post('/api/v2/Live_history/addTotal',
        {
          course_id:this.$route.query.course_id,
          lesson_id:this.$route.query.lesson_id,
          lesson_type:1
        },{
        headers:{
          'token':localStorage.getItem('token') || ""
        },
      }).then(res =>{
        if (res.data.code === 1) {
        }
      })
    },
    // 播放记录计算与提交
    sumbitHistory(callback) {
      this.endTime=Date.parse(new Date())
      let data = {
        course_id: this.course_id,
        lesson_id: this.lesson_id,
        lesson_type: 1,
        array_data:[[0,0]],
        last_time: this.current_time,
        see_video_time: this.current_time,
        terminal: 4
      }

      var obj={
        study_duration_type: 1,
        study_time: [[this.startTime/1000,this.endTime/1000]]
      }
      this.incrUserStudyTime(obj);
      this.$http.post('/api/v2/Live_history/addTime',{...data},{
        headers:{
          'token':localStorage.getItem('token') || ""
        }
      }).then(res =>{
          if (res.data.code === 1) {
            if(callback){
              callback()
            }
          }
      })
    },
    //统计学习时长
    incrUserStudyTime(obj) {
        this.$http.post("/api/v2/member/incrUserStudyTime",obj,{
            headers:{
              'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'',
            }
        }).then(res=>{
          // this.startTime==''
          // this.endTime=''
          console.log(res,"统计学习时长")
        })
    },
    toOrder() {
      this.$router.push({
        name: "submitOrder",
        params: { course_id: this.$route.query.course_id }
      });
    },
    flashChecker() {
      var hasFlash = 0; //是否安装了flash
      var flashVersion = 0; //flash版本
      if (document.all) {
        var swf = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
        if (swf) {
          hasFlash = 1;
          VSwf = swf.GetVariable("$version");
          flashVersion = parseInt(VSwf.split(" ")[1].split(",")[0]);
        }
      } else {
        if (navigator.plugins && navigator.plugins.length > 0) {
          var swf = navigator.plugins["Shockwave Flash"];
          if (swf) {
            hasFlash = 1;
            var words = swf.description.split(" ");
            for (var i = 0; i < words.length; ++i) {
              if (isNaN(parseInt(words[i]))) continue;
              flashVersion = parseInt(words[i]);
            }
          }
        }
      }
      return { f: hasFlash, v: flashVersion };
    },
    connect() {
      ws = new WebSocket(process.env.SOCKET_URL)//正式
      var that = this;
      var name = this.user_nickname,
        user_id = this.user_id,
        room_id = this.room_id,
        real_name = this.user_realname,
        phone = this.phone;

      ws.onopen = function() {
        console.log("已连接");

        // var login_data = `{"type":"login","client_name":"${name}","room_id":"${room_id}","user_id":"${user_id},"client_real_name":"${client_real_name}"}`;
        // var login_data = `{"type":"login","client_name":"${name}","room_id":"${room_id}","user_id":"${user_id}","client_real_name":"${real_name}"}`;
        var login_data = `{"type":"login","client_info":{"user_id":"${user_id}","nickname":"${name}","realname":"${real_name}","phone":"${phone}"},"room_id":"${room_id}"}`;
        ws.send(login_data);
      };

      // 服务端发来消息时
      ws.onmessage = function(e) {
        var data = JSON.parse(e.data);
        console.log(data);
        switch (data.type) {
          // 服务端ping客户端
          case "ping":
            ws.send('{"type":"pong"}');
            break;
          // 登录 更新用户列表
          case "login":
            that.list_flag = false;

            // if(data['client_list']){
            //     that.client_list = data.client_list;
            // }else{
            //     if (JSON.stringify(that.client_list) === '{}') {
            //         that.client_list[data.client_id] = data.client_name;
            //     }else{
            //         var istrue=true;
            //         for(let key  in that.client_list){
            //             if(that.client_list[key]==data.client_name){
            //                 istrue=false;
            //                 break;
            //             }
            //         }
            //         istrue ? that.client_list[data.client_id] = data.client_name: '';
            //     }
            // }

            if (data["client_list"]) {
              that.client_list = data.client_list;
            } else {
              // that.$set(that.client_list,data.from_cilent_info.user_id,data)
              var obj = {}
              obj.client_info = data.from_cilent_info
              that.$set(that.client_list,data.from_cilent_info.user_id,obj)
            }

            that.client_count = data.client_count;

            // for(let key  in that.now_client_list){
            //     let o={};
            //     o[key]=that.now_client_list[key]
            //     arr.push(o)
            //     b.push(that.now_client_list[key])
            // }
            // for(var i=0;i<arr.length;i++){

            //     var item=b[i];
            //     if(p.indexOf(item) === -1){
            //         p.push(item)
            //         obj[Object.keys(arr[i])[0]]=item;
            //     }
            // }

            // that.client_list=obj;

            // that.client_list = that.unique(that.now_client_list);

            // that.len = data.client_count;
            // that.list_flag = true;

            break;
          // 发言
          case "say_to_all":
            // say(data.from_client_id, data.from_client_name, data.content, data.time);
            // var chat = {
            //   content: data.content,
            //   name: data.from_client_name,
            //   realName: data.from_client_real_name || data.from_client_name,
            //   time: data.time,
            //   id: data.from_client_id
            // };
            var chat = {
              content: data.message_content,
              name: data.from_cilent_info.nickname,
              realName: data.from_cilent_info.realname? data.from_cilent_info.realname: data.from_cilent_info.nickname,
              phone: data.from_cilent_info.phone,
              time: data.message_time,
              id: data.from_cilent_info.client_id,
              user_id: data.from_cilent_info.user_id,
              message_id: data.message_id
            };

            that.chatLog.push(chat);
            break;
          // 撤回发言
          case 'withdraw':
            that.chatLog.forEach((e,index) => {
              if(e.message_id == data.message_extra.message_id){
                that.chatLog.splice(index,1);
              }
            })
            break;
          // 用户退出 更新用户列表
          case "logout":
            that.$delete(that.client_list,data.from_cilent_info.user_id)
            that.client_count = data.client_count;
            // that.list_flag = false;
            // delete that.client_list[data.from_client_id];

            // delete that.now_client_list[data.from_client_id];
            // that.client_list = that.unique(that.now_client_list);

            // that.len = data.client_count;
            // that.list_flag = true;
            break;
          // 用户多端登录后，一端用户被挤下线
          case "offline":
            // livePlayer.stop();
            that.livePlayer.pause();
            ws.close()
            that
              .$confirm("该视频正在被多台设备观看,若要继续观看，请点击确定")
              .then(() => {
                window.location.reload();
                this.connect();
              })
              .catch(() => {
                that.$router.go(-1);
              });
            break;
        }
      };

      ws.onclose = function() {
        console.log("连接关闭，定时重连",this.over);
        if(this.over){
          // that.connect()
        }
        // that.connect()
      };

      ws.onerror = function() {
        // console.log("出现错误");
        that.$toast.fail("问答区连接失败");
        that.connect();
      };

      this.over = () => {
        console.log("关闭了")
        ws.close();
      };
    },
    sendEnTer() {
      //消息发送
      var content = this.editText;
      //提问内容不允许为空
      if (/^\s+$/gi.test(content) || content == "") {
        this.$message.closeAll()
        this.$message.error("请输入提问内容");
        return false;
      }

      this.$http
        .get("/api/v2/Membercourse/checkTalkStatus", {
          //检测是否允许发言
          headers: {
            token:
              localStorage.getItem("token") !== null
                ? localStorage.getItem("token")
                : ""
          },
          params: {
            live_id: this.room_id,
            course_id: this.$route.query.course_id,
            user_msg:content
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            content = res.data.data
            ws.send(
              // '{"type":"say","to_client_id":"all","content":"' + content.replace(/\s*/g,"") + '"}'
              '{"type":"say_to_all","message_content":"' + content.replace(/\s*/g,"") + '"}'
            );
            this.editText = "";
          } else if (res.data.code === 0) {
            this.$message.error(res.data.msg);
          } else if (res.data.code === 10001) {
            store.commit("setDialogLogin", true);
          }
        })
        .catch(err => {
          console.log(this.over,"发送异常")
          this.$message.error("发送异常");
        });
    },
    recall(e) {
      if(this.user_func !==0){
        this.recall_msg = e.message_id
        this.show_tooltip = true
      }
    },
    isRecall(e) {
      if(e===1){
        var id = this.recall_msg,
         withdraw_data = `{"type":"withdraw","message_extra":{"message_id":"${id}"}}`
        ws.send(withdraw_data)
      }
      this.show_tooltip = false
    },
    outLogin() {
      //退出登录
      localStorage.removeItem("token");
      store.commit("setUserInfo", null);
      this.$router.push("/");
    },
    showDialogLogin(val) {
      //弹出登录窗口
      store.commit("setDialogLogin", val);
    },
    showDialogSignIn(val) {
      //弹出注册窗口
      store.commit("setDialogSignIn", val);
    },
    back() {
      this.$router.go(-1); //返回上一层
    },
    unique(reobj) {
      var arr = [],
        obj = {},
        b = [],
        p = [];
      for (let key in reobj) {
        let o = {};
        o[key] = reobj[key];
        arr.push(o);
        b.push(reobj[key]);
      }
      for (var i = 0; i < arr.length; i++) {
        var item = b[i];
        if (p.indexOf(item) === -1) {
          p.push(item);
          obj[Object.keys(arr[i])[0]] = item;
        }
      }
      return obj;
    }
  }
};
</script>

<style scoped>
.live_box {
  width: 100%;
  height: 100%;
  background: #333333;
  overflow: hidden;
  padding-bottom: 90px;
  box-sizing: border-box;
}
.live_head {
  width: 100%;
  background: #222;
  height: 60px;
}
.live_head_conter {
  font-size: 18px;
  margin: 0 50px;
  line-height: 60px;
}
.live_title {
  float: left;
  color: #fff;
}
.live_title_back {
  color: #00c590;
  margin-right: 30px;
  cursor: pointer;
}
.live_title i {
  display: inline-block;
  width: 8px;
  height: 15px;
  background: url("../assets/more.png") no-repeat 0 0;
  background-size: cover;
  margin-right: 10px;
}
.live_user_name {
  cursor: pointer;
  float: right;
  color: #fff;
}
.live_main {
  margin: 0 50px;
  height: 100%;
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.live_main_left {
  width: 100%;
  height: 100%;
  /* margin-right: 400px; */
  padding-right: 400px;
  box-sizing: border-box;
}
.live_main_right {
  width: 400px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  background: #222222;
  box-sizing: border-box;
  padding-bottom: 60px;
}
.videoplay {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.chat_wrap,.user_wrap {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  position: relative;
  box-sizing: border-box;
  padding-top: 50px;
}
.user_wrap{
  padding: 0;
}
.chat_wrap_title {
  position: absolute;
  top: 0;
  display: flex;
  color: #fff;
  width: 100%;
  height: 50px;
  z-index: 999;
}
.chat_wrap_title_student{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 24px !important;
  background: linear-gradient(
    30deg,
    rgba(9, 209, 120, 1),
    rgba(0, 202, 129, 1)
  );
}
.chat_tab{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  font-size: 14px;
  cursor: pointer;
  background: #999;
  color: #fff;
}
.chat_tab_online{
  margin-top: 5px;
}
.chat_tab_active{
  background: linear-gradient(
    30deg,
    rgba(9, 209, 120, 1),
    rgba(0, 202, 129, 1)
  );
}
.chat_wrap_title span:first-child {
  font-size: 16px;
}
.user-con{
  box-sizing: border-box;
  padding-left: 10px;
  margin-top: 10px;
}
.chat-item,.user-item {
  display: flex;
}
.user-item{
  align-items: center;
}
.user-item{
  color: #fff;
}
.user-item img{
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
.uname,
.ucontent {
  font-size: 16px !important;
  color: #999999;
  margin: 0;
  word-break: break-all;
}
.uname{
  min-width: 60px;
  max-width: 201px;
}
.ucontent {
  word-break: break-all;
  color: #ffffff;
  margin: 0 5px;
}
.edit-text_box {
  height: 50px;
  box-sizing: border-box;
  background: #666666;
  /* padding: 10px 20px; */
  position: relative;
}
.edit-text {
  box-sizing: border-box;
  width: 260px;
  height: 40px;
  line-height: 30px;
  background: #333;
  color: #fff;
  padding-left: 21px;
  font-size: 16px;
}
textarea,
.btn-a {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
textarea {
  resize: none;
  height: 40px;
  line-height: 40px;
  width: 260px;
  border-radius: 20px;
  left: 20px;
  outline: none;
  /* box-sizing: border-box; */
}
textarea::-webkit-scrollbar {
  display: none; /* 去滚动条 */
}
.btn-a {
  width: 80px;
  height: 40px;
  font-size: 18px;
  background: linear-gradient(
    30deg,
    rgba(9, 209, 120, 1),
    rgba(0, 202, 129, 1)
  );
  color: #ffffff;
  display: inline-block;
  text-align: center;
  line-height: 40px;
  border-radius: 20px;
  right: 20px;
}
/* 消息撤回框 */
.tooltip{
  width: 300px;
  height: 150px;
  position: fixed;
  top: 50%;
  right: 94px;
  /* transform: translate(-50%,-50%); */
  transform: translateY(-50%);
  background: #ffffff;
  border-radius: 20px;
}
.tooltip_title{
  padding-top: 20px;
  font-size: 32px;
  display: flex;
  justify-content: center;
}
.tooltip_btn_box{
  display: flex;
	margin-top: 18px;
	justify-content: center;
}
.tooltip_btn{
  width: 80px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #09d178;
  color: #ffffff;
  border-radius: 20px;
}
/* 用户列表 */
.online_list_warp {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  /* padding-left: 30px; */
  /* height: 300px; */
  /* width: 230px; */
}
.online_uer_list {
  width: 150px;
  height: 290px;
  overflow: auto;
  border-radius: 10px 0px 0px 10px;
  /* position: fixed; */
  /* right: 0;
        top: 50%;
        transform: translateY(-50%); */
  background: #fff;
}
.show_btn {
  position: absolute;
  border-radius: 10px 0px 0px 10px;
  width: 30px;
  height: 100px;
  font-size: 18px;
  background: #00c590;
  color: #fff;
  left: -30px;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
}
.wrap_show_btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.online_uer_list ul {
  margin-top: 0;
  font-size: 16px;
}
.online_num {
  height: 35px;
  width: 100%;
  font-size: 16px;
  color: #00c590;
  text-align: center;
  line-height: 35px;
  border-bottom: 1px solid #00c590;
}
.online_user_item {
  /* height: 35px; */
  width: 100%;
  text-align: center;
  /* line-height: 30px; */
  padding-top: 10px;
}
.wrap_dot {
  display: inline-block;
  margin-right: 8px;
}
.online_list_dot {
  width: 6px;
  height: 6px;
  display: inline-block;
  background: #00c590;
  border-radius: 50%;
  vertical-align: middle;
}
.catalog_logo {
  width: 20px;
  height: 20px;
  display: inline-block;
  background: url("../assets/catalog.png") no-repeat 0 0;
  background-size: cover;
}
.online_active {
  animation: opendoor 0.3s normal forwards;
}
@keyframes opendoor {
  from {
    width: 0;
  }
  to {
    /* width: 100%; */
    width: 150px;
  }
}
.close {
  animation: close 0.3s normal forwards;
}
@keyframes close {
  0% {
    /* width: 100%; */
    width: 150px;
  }
  100% {
    width: 0;
    opacity: 0;
  }
}
/* .apadding {
        animation: openpadding 0.3s normal forwards;
    } */
@keyframes openpadding {
  from {
    padding-right: 0;
  }
  to {
    /* width: 100%; */
    padding-right: 150px;
  }
}
/* .cpadding {
        animation: closepadding 0.3s normal forwards;
    } */
@keyframes closepadding {
  0% {
    /* width: 100%; */
    padding-right: 150px;
  }
  100% {
    padding-right: 0;
  }
}
.oleft {
  animation: openleft 0.3s normal forwards;
}
@keyframes openleft {
  from {
    right: 0;
  }
  to {
    /* width: 100%; */
    right: 150px;
  }
}
.cleft {
  animation: closeleft 0.3s normal forwards;
}
@keyframes closeleft {
  0% {
    /* width: 100%; */
    right: 150px;
  }
  100% {
    right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/live.vue